var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.0956C5.08223 1.0956 1.0956 5.08223 1.0956 10C1.0956 14.9178 5.08223 18.9044 10 18.9044C14.9178 18.9044 18.9044 14.9178 18.9044 10C18.9044 5.08223 14.9178 1.0956 10 1.0956ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5845 2.49081C16.7821 2.71991 16.7566 3.06581 16.5275 3.26341C14.7762 4.77388 12.4972 5.69473 9.99939 5.69473C7.50322 5.69473 5.22385 4.78536 3.47128 3.27376C3.24218 3.07616 3.21664 2.73026 3.41424 2.50116C3.61184 2.27206 3.95774 2.24653 4.18684 2.44412C5.7472 3.78993 7.77464 4.59914 9.99939 4.59914C12.2225 4.59914 14.2503 3.7807 15.8119 2.43377C16.041 2.23617 16.3869 2.26171 16.5845 2.49081Z",
    fill: "#146EB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99939 15.4003C7.7763 15.4003 5.7485 16.2187 4.18684 17.5657C3.95774 17.7632 3.61184 17.7377 3.41424 17.5086C3.21664 17.2795 3.24218 16.9336 3.47128 16.736C5.22254 15.2255 7.50156 14.3047 9.99939 14.3047C12.4972 14.3047 14.7762 15.2255 16.5275 16.736C16.7566 16.9336 16.7821 17.2795 16.5845 17.5086C16.3869 17.7377 16.041 17.7632 15.8119 17.5657C14.2503 16.2187 12.2225 15.4003 9.99939 15.4003Z",
    fill: "#146EB4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66249 0.118224C9.8617 -0.0394078 10.1431 -0.0394078 10.3423 0.118224C12.8816 2.12752 14.5361 5.83231 14.5361 10C14.5361 14.1677 12.8816 17.8725 10.3423 19.8818C10.1431 20.0394 9.8617 20.0394 9.66249 19.8818C7.12327 17.8725 5.46875 14.1677 5.46875 10C5.46875 5.83231 7.12327 2.12752 9.66249 0.118224ZM10.0024 1.26341C7.96233 3.08564 6.56435 6.29482 6.56435 10C6.56435 13.7052 7.96233 16.9144 10.0024 18.7366C12.0425 16.9144 13.4405 13.7052 13.4405 10C13.4405 6.29482 12.0425 3.08564 10.0024 1.26341Z",
    fill: "#146EB4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.0009C0 9.69838 0.245258 9.45312 0.547798 9.45312H19.4522C19.7547 9.45312 20 9.69838 20 10.0009C20 10.3035 19.7547 10.5487 19.4522 10.5487H0.547798C0.245258 10.5487 0 10.3035 0 10.0009Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIcon);
export default __webpack_public_path__ + "static/media/web-icon.10750ddd5ae76090b1fc822551c15bff.svg";
export { ForwardRef as ReactComponent };